import {Action, action} from 'easy-peasy';
import {AdditionalFilter, AdditionalSearchFilter, AllFields} from 'entities/chartFilters';
import {SearchResultEvent, SearchType} from 'entities/search';
import {TimelineByDateChartData} from 'entities/chartData';
import {EventTextFieldOption} from 'entities/event';


export interface SearchQueryErrors {
    query_string?: string;
}

export interface SearchParams {
    query_string?: string;
    fields_to_query?: string;
    all_fields?: AllFields;
}

export type SearchSortType = 'relevance' | 'event_datetime' | 'event_datetime_asc';

export interface SearchStoreModel {
    items: SearchResultEvent[];
    loadSearchResults: Action<SearchStoreModel, SearchResultEvent[]>;
    paramsSetter: boolean;
    setParamsSetter: Action<SearchStoreModel>;
    resetParamsSetter: Action<SearchStoreModel>;
    activeWord: null | string;
    setActiveWord: Action<SearchStoreModel, string | null>;
    headerActiveWord: null | string;
    setHeaderActiveWord: Action<SearchStoreModel, string | null>;
    similarWords: string[];
    setSimilarWords: Action<SearchStoreModel, string[]>;
    loadingSimilarWords: boolean;
    setLoadingSimilarWords: Action<SearchStoreModel, boolean>;
    headerSimilarWords: string[];
    setHeaderSimilarWords: Action<SearchStoreModel, string[]>;
    loadingHeaderSimilarWords: boolean;
    setLoadingHeaderSimilarWords: Action<SearchStoreModel, boolean>;
    errors: SearchQueryErrors;
    setErrors: Action<SearchStoreModel, SearchQueryErrors>;
    searchPagesList: number[];
    setSearchPagesList: Action<SearchStoreModel, number[]>;
    searchCurrentPage: number;
    setSearchCurrentPage: Action<SearchStoreModel, number>;
    searchResultsCount: number;
    setSearchResultsCount: Action<SearchStoreModel, number>;
    searchData: TimelineByDateChartData[];
    setSearchData: Action<SearchStoreModel, TimelineByDateChartData[]>;
    queryDuration: string;
    setQueryDuration: Action<SearchStoreModel, string>;
    params: SearchParams;
    setParams: Action<SearchStoreModel, SearchParams>;
    searchQuery: string;
    setSearchQuery: Action<SearchStoreModel, string>;
    headerSearchQuery: string;
    setHeaderSearchQuery: Action<SearchStoreModel, string>;
    fieldToQuery: EventTextFieldOption;
    setFieldToQuery: Action<SearchStoreModel, EventTextFieldOption>;
    sortTypeQuery: SearchSortType;
    setSortTypeQuery: Action<SearchStoreModel, SearchSortType>;
    viewTypeQuery: SearchType;
    setViewTypeQuery: Action<SearchStoreModel, SearchType>;
    searchQueryAllFields: AllFields;
    setSearchQueryAllFields: Action<SearchStoreModel, AllFields>;
    searchQueryAdditionalFilters: AdditionalSearchFilter[];
    setSearchQueryAdditionalFilters: Action<SearchStoreModel, AdditionalFilter[]>;
    loading: boolean;
    setLoading: Action<SearchStoreModel, boolean>;
}

export default <SearchStoreModel>{
    items: [],
    loadSearchResults: action((state, searchResultsList) => {
        state.items = searchResultsList;
    }),
    paramsSetter: false,
    setParamsSetter: action((state) => {
        state.paramsSetter = true;
    }),
    resetParamsSetter: action((state) => {
        state.paramsSetter = false;
    }),
    activeWord: null,
    setActiveWord: action((state, activeWord) => {
        state.activeWord = activeWord;
    }),
    headerActiveWord: null,
    setHeaderActiveWord: action((state, headerActiveWord) => {
        state.headerActiveWord = headerActiveWord;
    }),
    similarWords: [],
    setSimilarWords: action((state, similarWords) => {
        state.similarWords = similarWords;
    }),
    loadingSimilarWords: false,
    setLoadingSimilarWords: action((state, loadingSimilarWords) => {
        state.loadingSimilarWords = loadingSimilarWords;
    }),
    headerSimilarWords: [],
    setHeaderSimilarWords: action((state, headerSimilarWords) => {
        state.headerSimilarWords = headerSimilarWords;
    }),
    loadingHeaderSimilarWords: false,
    setLoadingHeaderSimilarWords: action((state, loadingHeaderSimilarWords) => {
        state.loadingHeaderSimilarWords = loadingHeaderSimilarWords;
    }),
    errors: {},
    setErrors: action((state, errors) => {
        state.errors = errors;
    }),
    searchPagesList: [],
    setSearchPagesList: action((state, searchPagesList) => {
        state.searchPagesList = searchPagesList;
    }),
    searchCurrentPage: 1,
    setSearchCurrentPage: action((state, searchCurrentPage) => {
        state.searchCurrentPage = searchCurrentPage;
    }),
    searchResultsCount: 0,
    setSearchResultsCount: action((state, searchResultsCount) => {
        state.searchResultsCount = searchResultsCount;
    }),
    searchData: [],
    setSearchData: action((state, searchData) => {
        state.searchData = searchData;
    }),
    queryDuration: '0',
    setQueryDuration: action((state, queryDuration) => {
        state.queryDuration = queryDuration;
    }),
    params: {},
    setParams: action((state, params) => {
        state.params = params;
    }),
    searchQuery: '',
    setSearchQuery: action((state, searchQuery) => {
        state.searchQuery = searchQuery;
    }),
    headerSearchQuery: '',
    setHeaderSearchQuery: action((state, headerSearchQuery) => {
        state.headerSearchQuery = headerSearchQuery;
    }),
    fieldToQuery: EventTextFieldOption.EventText,
    setFieldToQuery: action((state, fieldToQuery) => {
        state.fieldToQuery = fieldToQuery;
    }),
    sortTypeQuery: 'relevance',
    setSortTypeQuery: action((state, sortTypeQuery) => {
        state.sortTypeQuery = sortTypeQuery;
    }),
    viewTypeQuery: SearchType.Default,
    setViewTypeQuery: action((state, viewTypeQuery) => {
        state.viewTypeQuery = viewTypeQuery;
    }),
    searchQueryAllFields: {},
    setSearchQueryAllFields: action((state, searchQueryAllFields) => {
        state.searchQueryAllFields = searchQueryAllFields;
    }),
    searchQueryAdditionalFilters: [],
    setSearchQueryAdditionalFilters: action((state, searchQueryAdditionalFilters) => {
        state.searchQueryAdditionalFilters = searchQueryAdditionalFilters?.map(filter => {
            const {description, ...additionalSearchFilter} = filter;
            return additionalSearchFilter;
        })
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};
